module.exports = __webpack_public_path__ + "img/horizontal_7_7_8019.134b0429.png";